// networkConfig.js
const NETWORKS = {
  mainnet: {
    name: 'mainnet',
    rpc: 'https://mainnet.smartpy.io',
    contract: 'KT1A1v3dEDRhU9sbhuXJG2n5pkpWnMhxDkjZ'
  },
  ghostnet: {
    name: 'ghostnet',
    rpc: 'https://rpc.ghostnet.teztnets.com',
    contract: 'KT1NGK65f6yQgiPpP4kjVRXr6QiGS4iiM5P1'
  }
};
export default NETWORKS;

//https://mainnet.tezos.ecadinfra.com CORS